// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  value: "",
  categorie: "",
  accesInvestisseur: "",
  accesCgp: "",
  currentPage: 1,
  order: "asc",
  sortField: "ordre",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_TYPES_PUBLIPOSTAGES:
      return { ...state, value: action.payload };
    case actionTypes.SET_CATEGORIE_TYPES_PUBLIPOSTAGES:
      return { ...state, categorie: action.payload };
    case actionTypes.SET_CURRENT_PAGE_TYPES_PUBLIPOSTAGES:
      return { ...state, currentPage: action.payload };
    case actionTypes.SET_ORDER_TYPES_PUBLIPOSTAGES:
      return { ...state, order: action.payload };
    case actionTypes.SET_SORT_FIELD_TYPES_PUBLIPOSTAGES:
      return { ...state, sortField: action.payload };
    case actionTypes.SET_ACCES_INVESTISSEUR_TYPES_PUBLIPOSTAGES:
      return { ...state, accesInvestisseur: action.payload };
    case actionTypes.SET_ACCES_CGP_TYPES_PUBLIPOSTAGES:
      return { ...state, accesCgp: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
